import RandingStyle4 from "../../randing/RandingStyle4";

function Randing037({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle4
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/037/24122401.png`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/003/01_241101_02.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/037/24122403.jpg`} // 스텝 변경되는 이미지
      benefitInfoPosition="top"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/003/01_241101_05.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
    />
  );
}

export default Randing037;
